import API from "helpers/api";
import { Apis } from "services/api";
import { getAPIResponse } from "helpers/getApiResponse";
import { defaultPageSize } from "helpers/utils";

export const getAuditHistoryList = async ({
	pageNumber = 1,
	pageSize = defaultPageSize(),
	fromDate = "",
	toDate = "",
	entityTypes = [],
	actions = [],
	userIds = [],
	sortField = "dateTime",
	sortOrder = "desc",
}) => {
	try {
		const payload = {
			pageNumber,
			pageSize,
			fromDate: fromDate || null,
			toDate: toDate || null,
			entityTypes,
			actions,
			userIds,
			sortField,
			sortOrder,
		};
		let response = await API.post(`${Apis.Audits}/search`, payload);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

// Same contract as getFeedbackUsers: returns users with real User IDs, which is
// what the audit trail stores. useUsers passes siteAppId; the API scopes by token
export const getAuditUsers = async () => {
	try {
		let response = await API.get(`${Apis.Audits}/users`);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const getAuditHistoryCount = async ({
	fromDate = "",
	toDate = "",
	entityTypes = [],
	actions = [],
	userIds = [],
}) => {
	try {
		const payload = {
			fromDate: fromDate || null,
			toDate: toDate || null,
			entityTypes,
			actions,
			userIds,
		};
		let response = await API.post(`${Apis.Audits}/count`, payload);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const getChangeStatusReasons = async () => {
	try {
		let response = await API.get(`${Apis.ChangeStatusReasonsList}`);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const restoreAuditEntity = async (payload) => {
	try {
		let response = await API.post(`${Apis.Audits}/restore`, payload);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};
